import React from 'react';
import CoolMascot from '../../../../assets/cool-mascot.png';
import ShoutMascot from '../../../../assets/shout-mascot.png';
import WhatsAppNumberDropdown from '../settings/WhatsAppNumberDropdown';
import { DESCRIPTIONS } from '../utilities/constants';

const ConnectFacebook = ({ step, loginStatus, isLoggedIn, onPhoneNumberSelect }) => {
  const isFinalStep = step === 4;

  return (
    <>
      <div className="mascot">
        <img
          src={isFinalStep ? CoolMascot : ShoutMascot}
          alt={isFinalStep ? 'Cool Mascot' : 'Shout Mascot'}
        />
      </div>
      <div className="connect-facebook-wrapper">
        <h2>Connect WhatsApp Business Platform {loginStatus !== '' && `(${loginStatus})`}</h2>
        {isFinalStep ? (
          <>
            <p className="description">You're all set and ready to start!</p>
            <WhatsAppNumberDropdown
              isLoggedIn={isLoggedIn}
              onPhoneNumberSelect={onPhoneNumberSelect}
            />
          </>
        ) : (
          <>
            <p className="description">{DESCRIPTIONS.CONNECT_FACEBOOK}</p>
          </>
        )}
      </div>
    </>
  );
};

export default ConnectFacebook;
